import { DataResponse } from "shared/models";
import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionRequest } from "../shared/models/transaction.model";

export const transactionRefundRequestService = createApi({
    reducerPath: "transactionRefundRequestService",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getList: builder.mutation<DataResponse<any>, any>({
            query: (params) => ({
                url: `/refund-request`,
                method: "POST",
                body: params,
                headers: {
                      PageName: "transactionRefundRequest",
                  },
            }),
        }),
        getDetail: builder.query<any, { id: any }>({
            query: (params) => ({
                url: `/refund-request/${params?.id}`,
                method: "GET",
                headers: {
                    PageName: "transactionRefundRequest",
                },
            }),
        }),
        approvalRequest: builder.mutation<DataResponse<any>, any>({
            query: ({ params}) => ({
                url: `/refund-request/${params?.id}`,
                body: { params },
                method: "PUT",
                headers: {
                    PageName: "transactionRefundRequest",
                },
            }),
        }),
    }),
});

export const {
    useGetListMutation,
    useGetDetailQuery,
    useLazyGetDetailQuery,
    useApprovalRequestMutation,
} = transactionRefundRequestService